import moment from 'moment';
/**
 * Days of a maintenance sheet.
 *
 * The days of a sheet (maintenance.days, separated by commas) are saved as numbers relative to the month
 * of the sheet (maintenance.month and maintenance.year), so a sheet can include days of the previous or
 * of the following month:
 *
 *      1 = first day of the month of the sheet        31 = day 31
 *     32 = the day after the 31st (1st of the next month if the month has 31 days), 33 = the next one...
 *      0 = last day of the previous month             -1 = the day before that one
 *
 * Example: the sheet of July 2026 for the weekend Friday Jul 31 - Sunday Aug 2 is saved as "31,32,33".
 *          The same weekend in the sheet of August 2026 would be "0,1,2".
 *
 * The sheets whose days are all inside their month (all the ones created before this was possible)
 * keep exactly the same values, so nothing has to be migrated.
 *
 * This is the only place that knows this convention: use it to convert between days and dates.
 */
export default class MaintenanceDays {
    static firstDayOf(year, month) {
        return moment([year, month - 1, 1]);
    }
    /** Day number of a sheet -> date */
    static toDate(year, month, day) {
        return MaintenanceDays.firstDayOf(year, month).add(Number(day) - 1, 'days').startOf('day').toDate();
    }
    /** Date -> day number of a sheet */
    static toDay(year, month, date) {
        return moment(date).startOf('day').diff(MaintenanceDays.firstDayOf(year, month), 'days') + 1;
    }
}
